/**
 * Centralized configuration from environment variables.
 * All values use VUE_APP_ prefix (required by Vue CLI for client exposure).
 * Fallbacks ensure the app works when .env is missing or incomplete.
 *
 * SECURITY: Do not put secrets here that must stay server-side only.
 * VUE_APP_* vars are embedded in the client bundle at build time.
 */

function env(key, fallback) {
  const v = process.env[key];
  return (v !== undefined && v !== null && String(v).trim() !== '') ? String(v).trim() : fallback;
}

/** Backend root URL (no trailing slash), e.g. https://bildungsangebote-kiel.de */
const baseUrl = env('VUE_APP_BASE_URL', 'https://bildungsangebote-kiel.de').replace(/\/+$/, '');

/**
 * Full API base URL with trailing slash.
 * If VUE_APP_API_BASE_URL is set, that wins; otherwise baseUrl + /api/.
 */
const apiBaseUrlRaw = env('VUE_APP_API_BASE_URL', '') || `${baseUrl}/api/`;
const apiBaseUrl = apiBaseUrlRaw.replace(/\/+$/, '') + '/';

export default {
  /** Backend root for asset URLs (logos, etc.) */
  baseUrl,
  /** API base URL for axios requests */
  apiBaseUrl,

  /** App and content type ids from ContentHub backend */
  appId: env('VUE_APP_APP_ID', '3'),
  institutionId: env('VUE_APP_INSTITUTION_CONTENT_TYPE_ID', '1'),
  offerId: env('VUE_APP_OFFER_CONTENT_TYPE_ID', '2'),
  kultourId: env('VUE_APP_KULTOUR_CONTENT_TYPE_ID', '12'),
  attractionId: env('VUE_APP_ATTRACTION_CONTENT_TYPE_ID', '14'),

  /** CMS content IDs */
  impressumContentId: env('VUE_APP_IMPRESSUM_CONTENT_ID', '232159'),
  datenschutzContentId: env('VUE_APP_DATENSCHUTZ_CONTENT_ID', '232161'),
  bfeContentId: env('VUE_APP_BFE_CONTENT_ID', '240366'),

  /** API key for X-Api-Key header (required when backend enforces) */
  apiKey: env('VUE_APP_API_KEY', ''),
};

